import React from 'react';

export default function Education() {
  return (
    <section id="education" className="py-16 lg:py-24 bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">

        <p className="font-mono text-sky-400 text-xs sm:text-sm tracking-widest mb-2">05. Education &amp; Languages</p>
        <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-slate-100 mb-8 lg:mb-12">Background</h2>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">

          {/* Education */}
          <div className="bg-slate-800/50 border border-slate-700/60 rounded-xl p-5 sm:p-7">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-sky-500/10 border border-sky-500/20 text-sky-400 flex items-center justify-center shrink-0">
                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                </svg>
              </div>
              <div>
                <h3 className="text-slate-100 font-bold text-base sm:text-lg mb-0.5">Bachelor of Computer Science</h3>
                <p className="text-sky-400 font-medium text-sm mb-1">Baltistan University, Skardu</p>
                <p className="font-mono text-xs text-slate-500">2012 – 2016</p>
              </div>
            </div>
          </div>

          {/* Languages */}
          <div className="bg-slate-800/50 border border-slate-700/60 rounded-xl p-5 sm:p-7">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-sky-500/10 border border-sky-500/20 text-sky-400 flex items-center justify-center shrink-0">
                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-slate-100 font-bold text-base sm:text-lg mb-3 sm:mb-4">Languages</h3>
                <div className="space-y-3">
                  {[
                    { lang: 'English', level: 'Professional Working',  pct: 85  },
                    { lang: 'Urdu',    level: 'Native / Professional', pct: 100 },
                    { lang: 'Balti',   level: 'Native',                pct: 100 },
                  ].map(l => (
                    <div key={l.lang}>
                      <div className="flex justify-between mb-1.5">
                        <span className="text-slate-300 text-xs sm:text-sm font-medium">{l.lang}</span>
                        <span className="text-slate-500 text-xs">{l.level}</span>
                      </div>
                      <div className="h-1 bg-slate-700 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-sky-500 to-sky-400 rounded-full"
                          style={{ width: `${l.pct}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
